/****   request.js   ****/
// https://blog.csdn.net/weixin_43216105/article/details/98877960
// 导入axios
import axios from 'axios'
import { Message } from 'element-ui'

import router from "../router/index.js"
import { showLoading, hideLoading } from '../js/loading'

//1. 创建新的axios实例，
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 1000 * 1000
})

// 2.请求拦截器
service.interceptors.request.use(config => {
  //添加token
  // const user = JSON.parse(localStorage.getItem('user'));
  const token = localStorage.getItem('token');
  if (token !== null) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.url.includes('/sys/log/export') || config.url.includes('/sys/zkdata/export')) {
    config.headers['Content-Type'] = 'application/octet-stream'

    // config.headers = { ...config.headers, 'Content-Type' : "application/octet-stream" }
    config.responseType = 'blob'
  }
  // 除文件意外统一以application/x-www-form-urlencoded上传
  if (config.headers['Content-Type'] != 'multipart/form-data' || config.headers['Content-Type'] != 'application/octet-stream') {
    config.headers['Content-Type'] = 'application/json'
  }
  showLoading()
  return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  //接收到响应数据并成功后的一些共有的处理，关闭loading等
  hideLoading()
  if (response.status == 200) {
    if (response.data.code == 40001 || response.data.code == 40002) {
      Message({
        message: "登陆过期，请重新登录",
        type: 'warning'
      })
      localStorage.clear()
      // location.reload()
      router.push('/login')
    }

    //判断是否是测试环境
    // if (process.env.NODE_ENV != 'development') {
    //   if(process.env.VUE_APP_BASE_URL.indexOf("114.215.175.214") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/192.168.101.200:8092/g,"114.215.175.214:8092")
    //     return JSON.parse(res)
    //   }
    //   else if(process.env.VUE_APP_BASE_URL.indexOf("192.168.101.200") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/114.215.175.214:8092/g,"192.168.101.200:8092")
    //     return JSON.parse(res)
    //   } else if(process.env.VUE_APP_BASE_URL.indexOf("192.168.100.101") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/114.215.175.214:8092/g,"192.168.100.101:8092")
    //     res = res.replace(/192.168.101.200:8092/g,"192.168.100.101:8092")
    //     return JSON.parse(res)
    //   } else if(process.env.VUE_APP_BASE_URL.indexOf("localhost") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/114.215.175.214:8092/g,"localhost:8092")
    //     res = res.replace(/192.168.101.200:8092/g,"localhost:8092")
    //     return JSON.parse(res)
    //   }
    // } else {
    //   if(process.env.VUE_APP_BASE_URL.indexOf("114.215.175.214") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/192.168.101.200:8092/g,"114.215.175.214:8092")
    //     return JSON.parse(res)
    //   }
    //   else if(process.env.VUE_APP_BASE_URL.indexOf("192.168.101.200") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/114.215.175.214:8092/g,"192.168.101.200:8092")
    //     res = res.replace(/192.168.101.44:8092/g,"192.168.101.200:8092")
    //     return JSON.parse(res)
    //   } else if(process.env.VUE_APP_BASE_URL.indexOf("192.168.100.101") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/114.215.175.214:8092/g,"192.168.100.101:8092")
    //     res = res.replace(/192.168.101.200:8092/g,"192.168.100.101:8092")
    //     return JSON.parse(res)
    //   } else if(process.env.VUE_APP_BASE_URL.indexOf("localhost") > 0){
    //     let res = JSON.stringify(response.data)
    //     res = res.replace(/114.215.175.214:8092/g,"localhost:8092")
    //     res = res.replace(/192.168.101.200:8092/g,"localhost:8092")
    //     return JSON.parse(res)
    //   }
    // }
    return response.data
  } 
  return response
}, error => {
  /***** 接收到异常响应的处理开始 *****/
  if (error && error.response) {
    // 1.公共错误处理
    // 2.根据响应码具体处理
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break;
      case 401:
        error.message = '未授权，请重新登录'
        break;
      case 403:
        error.message = '拒绝访问'
        break;
      case 404:
        error.message = '请求错误,未找到该资源'
        break;
      case 405:
        error.message = '请求方法未允许'
        break;
      case 408:
        error.message = '请求超时'
        break;
      case 500:
        error.message = '服务器端出错'
        break;
      case 501:
        error.message = '网络未实现'
        break;
      case 502:
        error.message = '网络错误'
        break;
      case 503:
        error.message = '服务不可用'
        break;
      case 504:
        error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
    // localStorage.clear();
    // router.push('/login')
    // location.reload()
  } else {
    // 超时处理
    // if (JSON.stringify(error).includes('timeout')) {
    //   message.error('服务器响应超时，请刷新当前页')
    // }
    error.message = '连接服务器失败'
  }
  hideLoading()
  // message.error(error.message);
  /***** 处理结束 *****/
  //如果不需要错误处理，以上的处理过程都可省略
  return Promise.reject(error.response)
})
//4.导入文件
export default service